import { render, staticRenderFns } from "./PnrContact.vue?vue&type=template&id=487d6c5a&scoped=true&"
import script from "./PnrContact.vue?vue&type=script&lang=js&"
export * from "./PnrContact.vue?vue&type=script&lang=js&"
import style0 from "./PnrContact.vue?vue&type=style&index=0&id=487d6c5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487d6c5a",
  null
  
)

export default component.exports